const mappedEnums = {
    proposal: {
        status: {
            "DRAFT": "Brouillon",
            "PENDING": "En attente",
            "APPROVED": "Approuvée",
            "REJECTED": "Rejetée",
            "COMPLETED": "Terminée",
            "PAID_IN_FULL": "Payé intégralement",
        },
        statusIcon: {
            "DRAFT": "fal fa-file-alt",
            "PENDING": "fal fa-clock",
            "APPROVED": "fal fa-check-circle",
            "REJECTED": "fal fa-times-circle",
            "COMPLETED": "fal fa-check-double",
            "PAID_IN_FULL": "fal fa-money-check-alt",
        },
        statusColor: {
            "DRAFT": "grey",
            "PENDING": "orange",
            "APPROVED": "green",
            "REJECTED": "red",
            "COMPLETED": "blue",
            "PAID_IN_FULL": "purple",
        },
    },
    proposalHistory: {
        type: {
            "CREATED": "Crée",
            "CHANGED": "Modifiée",
            "APPROVED": "Validée",
            "REJECTED": "Rejetée",
            "COMMENTED": "Commentaire",
        },
        typeColor: {
            "CREATED": "blue",
            "CHANGED": "orange",
            "APPROVED": "success",
            "REJECTED": "error",
            "COMMENTED": "purple",
        },
    },
    review: {
        levelColor: [
            "grey",
            "primary-lighten-2",
            "primary-lighten-1",
            "primary",
        ],
    },
};

export function enumFormatter(objectPath, objectString) {
    const parsedPath = objectPath.split(".");

    let currentPointer = mappedEnums;
    for (const key of parsedPath) {
        currentPointer = currentPointer[key];
    }

    return currentPointer[objectString];
};
